module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_2.efe256d0.png";